import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import devices from '../../common/styles/devices';

export const ModalContainer = styled.div`
  background-color: ${COLORS.white};
  border-radius: 10px;
  padding: 16px 16px 32px;
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  flex-direction: column;
  min-width: 400px;
  .proceed-btn {
    margin-top: 30px;
  }
  .deeplink-container {
    width: 100%;
    text-align: center;
    margin-top: 16px;
  }
  @media ${devices.mobileXL} {
    min-width: unset;
    width: 90%;
  }
`;

export const CloseWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  padding: 10px;
  cursor: pointer;
`;

export const WarningImgContainer = styled.div`
  margin-bottom: 8px;
`;
export const TitleText = styled.p`
  font-size: 18px;
  color: ${COLORS.black};
  font-weight: bold;
`;

export const MessageText = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${COLORS.textGrey};
  text-align: center;
  line-height: 24px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 10px;
  text-align: center;
`;
